// extracted by mini-css-extract-plugin
export default {"title":"pilih-marketing-penjual_title__HXIli"};